<template>
  <div class="form-component">
    <v-form ref="form" v-model="valid">
      <h3 class="form-title">
        <v-btn fab color="primary" @click="goBack()">
          <v-icon large>arrow_left</v-icon>
        </v-btn>
        {{ title }} Permiso
      </h3>

      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-text-field class="lance"
              ref="rolecode"
              label="Código"
              v-model="form.code"
              :rules="[v => !!v || 'Campo requerido']"
              :disabled="view">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field class="lance" 
              label="Nombre"
              v-model="form.name"
              :rules="[v => !!v || 'Campo requerido']"
              :disabled="view">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field class="lance"
              label="Descripción"
              v-model="form.description"
              :disabled="view">
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-flex xs12 class="divider"></v-flex>

        <div class="table-catalog table-catalog-border-first elevation-5">
          <table class="v-datatable v-table theme--light">
            <thead>
              <tr>
                <th class="text-xs-left">Módulo</th>
                <th class="text-xs-left">Alta</th>
                <th class="text-xs-left">Lectura</th>
                <th class="text-xs-left">Actualizar</th>
                <th class="text-xs-left">Borrar</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Usuarios</td>
                <td>
                  <v-switch hide-details v-model="form.userCreate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.userRead" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.userUpdate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.userDelete" color="primary" :disabled="view"></v-switch>
                </td>
              </tr>
              <tr>
                <td>Matriz de Permisos</td>
                <td>
                  <v-switch hide-details v-model="form.roleCreate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.roleRead" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.roleUpdate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.roleDelete" color="primary" :disabled="view"></v-switch>
                </td>
              </tr>
              <tr>
                <td>Proveedores</td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.SuppliersRead" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
              </tr>
              <tr>
                <td>Documentos</td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.DocumentsRead" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.DocumentsUpdate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
              </tr>
              <tr>
                <td>Complementos de Pago</td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.PaymentSupplementsRead" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.PaymentSupplementsUpdate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
              </tr>
              <tr>
                <td>Template de Facturas</td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.PaymentSupplementsRead" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.PaymentSupplementsUpdate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details color="primary" disabled=true></v-switch>
                </td>
              </tr>
              <tr>
                <td>Notificaciones</td>
                <td>
                  <v-switch hide-details v-model="form.NotificationConfigurationCreate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.NotificationConfigurationRead" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.NotificationConfigurationUpdate" color="primary" :disabled="view"></v-switch>
                </td>
                <td>
                  <v-switch hide-details v-model="form.NotificationConfigurationDelete" color="primary" :disabled="view"></v-switch>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-btn v-if="!view" solo color="submitBtn" @click="save()" :disabled="!valid || sending">Guardar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import { events } from '../main';
  import { _ } from 'underscore';

  export default {
    name: 'roleform',
    data() {
      return {
        form: {},
        id: '',
        loading: true,
        sending: false,
        switchColor:'blue',
        title: 'Nuevo',
        valid: true,
        view: false,
      }
    },
    methods: {
      dataInit() {
        if (this.id) {
          this.getRegistry(this.id);
          if (this.$route.name.includes('detail')) {
            this.view = true;
            this.title = 'Detalle de';
          } else {
            this.title = 'Editar';
          }
        } else {
          let newform = {};
          newform.userCreate = false;
          newform.userRead = false;
          newform.userUpdate = false;
          newform.userDelete = false;
          newform.roleCreate = false;
          newform.roleRead = false;
          newform.roleUpdate = false;
          newform.roleDelete = false;
          newform.MailConfigurationCreate = false;
          newform.MailConfigurationRead = false;
          newform.MailConfigurationUpdate = false;
          newform.MailConfigurationDelete = false;
          newform.SuppliersCreate = false;
          newform.SuppliersRead = false;
          newform.SuppliersUpdate = false;
          newform.SuppliersDelete = false;
          newform.DocumentsCreate = false;
          newform.DocumentsRead = false;
          newform.DocumentsUpdate = false;
          newform.DocumentsDelete = false;
          newform.PaymentSupplementsRead = false;
          newform.PaymentSupplementsUpdate = false;
          newform.MailReaderRead = false;
          newform.NotificationConfigurationCreate = false;
          newform.NotificationConfigurationRead = false;
          newform.NotificationConfigurationUpdate = false;
          newform.NotificationConfigurationDelete = false;
          this.form = newform;
          this.loading = false;
        }
      },
      getRegistry(id) {
        const self = this;
        this.$http.get('role/' + id)
          .then(response => {
            self.form = response.body;
          }, error => {
            self.snackbar('Error al obtener registro');
            this.$router.push('/rolelist');
          });
          this.loading = false;
      },
      goBack () {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/');
      },
      goTo(url) {
        this.$router.push(url);
      },
      save() {
        self = this;
        if (this.$refs.form.validate()) {
          this.sending = true;                    
          if (this.id) {
            this.form.updatedById = localStorage.getItem('userId');
            this.$http.put('role/' + self.id, self.form)
              .then(response => {
                self.snackbar('Registro actualizado con éxito');
                this.$router.push('/rolelist');                                
              }, error => {
                self.sending = false;                                
                let message = error.body.msg || 'Error al actualizar registro';
                self.snackbar(message);
                console.error(error);
              }
            );
          } else {
            self.form.createdById = localStorage.getItem('userId');
            self.form.updatedById = localStorage.getItem('userId');
            self.$http.post('role/', self.form)
              .then(response => {
                self.snackbar('Registro creado con éxito');
                this.$router.push('/rolelist');   
              }, error => {
                self.sending = false;                                
                let message = error.body.msg || 'Error al crear registro';
                self.snackbar(message);
                console.error(error);
              }
            );
          }
        }
      },
      snackbar(message) {
        events.$emit('snackbar', message);            
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.dataInit();
      this.$nextTick(() => {
        this.$refs.rolecode.$el.children[0].children[0].children[0].children[1].focus();
      });
    },
    computed: {
      selectAllCreate: {
        get: function() {
          let keys = Object.keys(this.form).filter(x => x.includes('Create'));
          let result = true;
          keys.forEach(key => {
            result = result && this.form[key];
          })
          return result;
        },
        set: function(newvalue) {
          let keys = Object.keys(this.form).filter(x => x.includes('Create'));
          let result = true;
          keys.forEach(key => {
            this.form[key] = newvalue;
          });
        }
      },
      selectAllRead: {
        get: function() {
          let keys = Object.keys(this.form).filter(x => x.includes('Read'));
          let result = true;
          keys.forEach(key => {
            result = result && this.form[key];
          });
          return result;
        },
        set: function(newvalue) {
          let keys = Object.keys(this.form).filter(x => x.includes('Read'));
          let result = true;
          keys.forEach(key => {
            this.form[key] = newvalue;
          });
        }
      },
      selectAllUpdate: {
        get: function() {
          let keys = Object.keys(this.form).filter(x => x.includes('Update'));
          let result = true;
          keys.forEach(key => {
            result = result && this.form[key];
          });
          return result;
        },
        set: function(newvalue) {
          let keys = Object.keys(this.form).filter(x => x.includes('Update'));
          let result = true;
          keys.forEach(key => {
            this.form[key] = newvalue;
          });
        }
      },
      selectAllDelete: {
        get: function() {
          let keys = Object.keys(this.form).filter(x => x.includes('Delete'));
          let result = true;
          keys.forEach(key => {
            result = result && this.form[key];
          });
          return result;
        },
        set: function(newvalue) {
          let keys = Object.keys(this.form).filter(x => x.includes('Delete'));
          let result = true;
          keys.forEach(key => {
            this.form[key] = newvalue;
          });
        }
      }
    }
  }
</script>

<style scoped>
.v-datatable >>> .v-input--selection-controls .v-input__append-outer, .v-datatable >>> .v-input--selection-controls .v-input__prepend-outer {
  margin-top: auto;
  margin-bottom: auto;
}

.table-catalog >>> table.v-table tr {
    border-bottom-width: 0 !important;
    height: 48px;
}
.table-catalog >>> table.v-table thead th:not(:first-child),
.table-catalog >>> table.v-table tbody td:not(:first-child) {
    border-left: solid 1px var(--v-textColor-base);
    padding-left: 80px;
    text-align: center !important;
}

.table-catalog >>> table.v-table tbody td div.v-input {
    display: inline-block;
}
.table-catalog-border-first >>> table.v-table thead th:not(:nth-child(2)),
.table-catalog-border-first >>> table.v-table tbody td:not(:nth-child(2)) {
    border: none;
}
div.table-catalog > div.v-datatable.v-table > div.v-datatable__actions {
    border: none;
}



.checkbox-select-all {
  align-items: flex-start;
  justify-content: flex-start;
}

.switch-input {
  align-items: center;
  justify-content: flex-end;
  margin: unset;
}

.container.grid-list-sm .layout .flex  {
  padding: 8px;
}
tr td:first-child {
  font-family: 'Montserrat', sans-serif;
}
</style>